import { render, staticRenderFns } from "./taskCenter.vue?vue&type=template&id=31f73fe7&scoped=true&"
import script from "./taskCenter.vue?vue&type=script&lang=js&"
export * from "./taskCenter.vue?vue&type=script&lang=js&"
import style0 from "./taskCenter.vue?vue&type=style&index=0&id=31f73fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f73fe7",
  null
  
)

export default component.exports